var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CircularProgress } from "@mui/material";
import { Modal } from "@mui/material";
import { useLoading } from "../Context/LoadingContext";
import TabPanel from "./TabPanel";
import "../../../@common/styles/styles.scss";
function LoginModal(props) {
    var isActive = props.isActive, handleClose = props.handleClose;
    var loading = useLoading().loading;
    var onClose = function () {
        handleClose();
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ open: isActive, onClose: onClose, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description", className: "modernization-centered-modal", "data-testid": "login-modal" }, { children: _jsx("div", __assign({ id: "modal-modal-description", className: "modernization-header__wrapper__right__buttons__login-area" }, { children: loading ? (_jsx("div", __assign({ className: "modernization-loader-block" }, { children: _jsx(CircularProgress, { className: "modernization-loader-spinner-main" }) }))) : (_jsx(TabPanel, {})) })) })) }));
}
export default LoginModal;
